var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.groups),function(group){return _c('KCheckbox',{key:group.id,attrs:{"label":group.name,"value":group.id},model:{value:(_vm.selectedGroupIds),callback:function ($$v) {_vm.selectedGroupIds=$$v},expression:"selectedGroupIds"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }